import type { ProgramRegistration, User } from '@lms/shared/types';

type ParticipantNipUser = Pick<User, 'legacyNip'> | null | undefined;
type ParticipantNipRegistration = Pick<ProgramRegistration, 'participantNip'>;

function normalizeParticipantNip(value: string | null | undefined): string | null {
  const normalized = value?.trim() ?? '';
  return normalized.length > 0 ? normalized : null;
}

/**
 * Returns the institution-wide NIP without ever treating a per-program
 * participant code as an NIP. The account value is authoritative; a
 * registration value is used only while an older browser session has not yet
 * received the refreshed account payload after registration.
 */
export function getParticipantNip(
  user: ParticipantNipUser,
  registrations: readonly ParticipantNipRegistration[] = []
): string | null {
  const accountNip = normalizeParticipantNip(user?.legacyNip);
  if (accountNip) return accountNip;

  for (const registration of registrations) {
    const registrationNip = normalizeParticipantNip(registration.participantNip);
    if (registrationNip) return registrationNip;
  }

  return null;
}
